import { createAction } from '@reduxjs/toolkit';

export const openBonusDetail = createAction('bonuses/openDetail');
export const closeBonusDetail = createAction('bonuses/closeDetail');
